export default {"src":"/_next/static/media/mountain_bike.44ba6e09.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};